import {
    faCircleSmall,
    faCoffee,
    faDoorOpen,
    faHouse,
    faLocationDot,
    faStairs,
    faStar
} from '@fortawesome/pro-solid-svg-icons';

export const DarkColor = '#333333';
export const LightColor = '#FFFFFF';

export const FloorColors = [
    {
        value: '#F4F4F4',
        label: 'Default'
    },
    {
        value: '#F8E7DA',
        label: 'Orange'
    },
    {
        value: '#F8F8DA',
        label: 'Yellow'
    },
    {
        value: '#E0F8DA',
        label: 'Green'
    },
    {
        value: '#DAF8F8',
        label: 'Cyan'
    },
    {
        value: '#DAE0F8',
        label: 'Blue'
    },
    {
        value: '#F6DAF8',
        label: 'Pink'
    },
    {
        value: '#F8DADB',
        label: 'Red'
    }
];

export const StandColors = [
    {
        value: '#D3D3D3',
        darker: '#444444',
        label: 'Default'
    },
    {
        value: '#A8D5E0',
        darker: '#244A54',
        label: 'Blue'
    },
    {
        value: '#FFC7A7',
        darker: '#8A431B',
        label: 'Orange'
    },
    {
        value: '#fff9a7',
        darker: '#61620d',
        label: 'Yellow'
    },
    {
        value: '#b7ffa7',
        darker: '#1b7617',
        label: 'Green'
    },
    {
        value: '#e5a7ff',
        darker: '#76176e',
        label: 'Purple'
    },
    {
        value: '#ffa7a7',
        darker: '#761717',
        label: 'Red'
    }
];

export const PinIcons = [
    {
        icon: faCircleSmall,
        value: 'circle-small',
        label: 'Circle'
    },
    {
        icon: faLocationDot,
        value: 'location-dot',
        label: 'Location'
    },
    {
        icon: faHouse,
        value: 'house',
        label: 'House'
    },
    {
        icon: faStar,
        value: 'star',
        label: 'Star'
    },
    {
        icon: faStairs,
        value: 'stairs',
        label: 'Stairs'
    },
    {
        icon: faDoorOpen,
        value: 'door',
        label: 'Door'
    },
    {
        icon: faCoffee,
        value: 'coffee',
        label: 'Coffee'
    }
];

export const DominantColors = [
    {
        value: DarkColor,
        label: 'Dark (Default)'
    },
    {
        value: '#1997ED',
        label: 'Cyan'
    },
    {
        value: '#8AA0A9',
        label: 'Grey'
    },
    {
        value: '#F5762D',
        label: 'Orange'
    },
    {
        value: '#EFE233',
        label: 'Yellow'
    },
    {
        value: '#17941B',
        label: 'Green'
    },
    {
        value: '#C56AEC',
        label: 'Purple'
    },
    {
        value: '#DD433F',
        label: 'Red'
    },
    {
        value: '#4365EC',
        label: 'Blue'
    },
    {
        value: '#FFB76F',
        label: 'Pantone'
    },
    {
        value: '#C58134',
        label: 'Brown'
    },
    {
        value: '#E4E4E4',
        label: 'Light'
    }
];

export const WallColors = [
    {
        value: 'white',
        label: 'White (Default)'
    }
];

export const FillWallColors = [
    {
        value: '#D1D1D1',
        label: 'Grey (Default)'
    }
];

export const TextColors = [
    {
        value: '#333333',
        label: 'Dark (Default)'
    },
    {
        value: '#FFFFFF',
        label: 'White'
    }
];

export type VariantAvailableIcons = 'landmark' | 'star';
